import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import { SectionTwoBody, SectionTwoDetails } from "types/api/blocks/sectionTwo";

function useSectionTwoApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionTwo = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionTwoDetails> => {
        return get<PathParamsWithId, undefined, SectionTwoDetails>({
            url: "/blocks/section-two/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionTwo = React.useCallback((body: SectionTwoBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionTwoBody, null>({
            url: "/blocks/section-two",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionTwo = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-two/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionTwo,
        saveSectionTwo,
        deleteSectionTwo
    };
}

export default useSectionTwoApi;